<p-toolbar>
  <div class="p-toolbar-group-left">
    <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>
    <span style="padding-top:2px;">
      <button (click)="loadReportData()"
              pButton type="button" 
              class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
              icon="pi pi-fw pi-refresh"></button>    
      <!-- Display only on bigger than md screens-->
      <span class="p-d-none p-d-md-inline">
        <button pButton pRipple 
                label="Excel Export" 
                class="p-button p-button-text" 
                [class.disabled]="exporting"
                icon="{{exporting ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-file-download'}}"
                (click)="exportToExcel()"></button>

      </span>

      <!-- Display only on smaller than md screens-->
      <span class="p-d-md-none">
        <button pButton pRipple 
                class="p-button-rounded p-button-success" 
                icon="pi pi-refresh" 
                type="button" 
                (click)="exportToExcel()"></button>

      </span>
    </span>
  </div>
</p-toolbar>

<div class="m-1" style="height:calc(100% - 36px)">
  <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
               size="default"
               color="#2f9cf2"
               type="line-scale-pulse-out"
               [name]="spinnerName"
               [fullScreen]="false">
    <p style="color:white" >Generating monthly income report... </p>
  </ngx-spinner>

  <p-table  [value]="reportItems" 
            [scrollable]="true" scrollHeight="flex"
            selectionMode="single" 
            styleClass="p-datatable-gridlines"
            sortField="dateValue" sortOrder="0" sortMode="single" (onSort)="onSort()">
    <ng-template pTemplate="header">
      <tr>
        <th class="p-text-bold" style="width:200px">Project No</th>
        <th class="p-text-bold">Project Description</th>
        <th class="p-text-bold" style="text-align: right;">Invoice Value</th>
        <th class="p-text-bold">Invoices</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-reportItem let-rowIndex="rowIndex">
      <tr *ngIf="rowGroupMetadata[reportItem.dateString].index === rowIndex" style="background-color:rgb(230, 248, 247);">
        <td style="width:200px;font-size:1.3rem;">
          <span class="p-text-bold">{{reportItem.dateString}}</span>
        </td>
        <td colspan="2" style="text-align: right;">
          <span class="p-text-bold" style="font-size:1.3rem;">{{util.formatCurrency(reportItem.monthTotal)}}</span>
        </td>
        <td></td>
      </tr>
      <tr>
        <td style="width:200px">
          {{reportItem.projectNo}}
        </td>
        <td>
          {{reportItem.projectDescription}}
        </td>
        <td style="text-align: right;">
          {{util.formatCurrency(reportItem.invoiceValue)}}
        </td>
        <td>
          {{reportItem.invoices}}
        </td>
      </tr>
    </ng-template>
  </p-table>
  
</div>

